import React from 'react'
import CardUI from '../../../../widgets/layout/CardUI'
import openAILite from '../../../../assets/finapp/openai-lite.png'
import openAIDark from '../../../../assets/finapp/openai-dark.png'

const KeyFinancialsUI = ({ context, loan, keyFinancials, keyFinancialsList, transformedList }) =>
  <CardUI title='Key financials metrics' className='g_m_bottom_100'>
    {
      keyFinancials.aiDesc &&
      <div className='g_flex_h g_flex_top g_m_bottom_100'>
        <img src={context.theme === 'lite' ? openAILite : openAIDark} alt="" width='20px' />
        <span className='g_m_left_50'>{keyFinancials.aiDesc}</span>
      </div>
    }
    <table>
      <thead>
        <tr>
          <th>Metrics</th>
          {
            keyFinancialsList.map((financialYear, i) =>
              <th key={i}>{financialYear.financialYear}</th>
            )
          }
        </tr>
      </thead>
      <tbody>
        {
          transformedList.map((item, i) =>
            <tr key={i}>
              <td>{item.lable}</td>
              {
                item.valueList.map((value) =>
                  <td className='g_text_right'>{value.value}</td>
                )
              }
            </tr>
          )
        }
      </tbody>
    </table>
  </CardUI>

export default KeyFinancialsUI
